module.exports = __webpack_public_path__ + "img/eco-friendly.00817b7.svg";